import React, { Component, useRef } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
} from "react-router-dom";

import {
  Conatiner_footer,
  Conatiner_footer_list,
  Conatiner_footer_list_container,
  Bottom_label,
} from "./style";
import "./about.scss";

import About from "./About";
import Brand_Distribution from "./Brand_Distribution";
import Fulfillment from "./Fulfillment";
import International_wholesale from "./International_wholesale";
import Marketing from "./Marketing";
import Backbutton from "../button/Backbutton";

const About_mainpage = () => {
  const button01 = useRef();

  const handleScroll = (ref) => {
    window.scrollTo({
      behavior: "smooth",
      top: "ref.current.offsetTop",
    });
  };

  return (
    <div className="About_mainpage">
      <div className="h1-text">
        iDEAL SHOWROOM FASHION AGENCY BASED IN SEOUL
      </div>
      <br />
      <div className="h1-text">General@idealppl.com INSTAGRAM</div>
      <br />
      <Backbutton />
      <div className="contents">
        <Router>
          <div className="contents_links_container">
            <NavLink id="contents_links" to="/about">
              1. ABOUT US
            </NavLink>
            <NavLink id="contents_links" to="/International_wholesale">
              2. INTERNATIONAL WHOLESALE
            </NavLink>
            <NavLink id="contents_links" to="/Marketing">
              3. FASHION MARKETING / PR /EVENT
            </NavLink>
            <NavLink id="contents_links" to="/Brand_Distribution">
              4. BRAND LICENSING & DISTRIBUTION
            </NavLink>
            <NavLink id="contents_links" to="/Fulfillment">
              5. FULFILLMENT
            </NavLink>
          </div>
          <Route exact path="/About" component={About}></Route>
          <Route exact path="/Fulfillment" component={Fulfillment}></Route>
          <Route exact path="/Marketing" component={Marketing}></Route>
          <Route
            exact
            path="/Brand_Distribution"
            component={Brand_Distribution}
          ></Route>
          <Route
            exact
            path="/International_wholesale"
            component={International_wholesale}
          ></Route>
        </Router>
      </div>

      {/* <div className="to_top_button">
        <button id="top" onClick={() => handleScroll(button01)}>
          To Top
        </button>
      </div> */}
      <div className="footer">
        <div className="right-align">
          <div>
            <p>iDEAL SHOWROOM </p>
            <p>2F, 15, Nonhyeon-ro 158-gil,</p>
          </div>
          <div>
            <p>Gangnam-gu, Seoul,</p>
            <p>Republic of Korea. 06025</p>
          </div>
          <div>
            <p>
              <img src="Images/About_pics/Phone.svg" />
              +82 70. 8898. 8681
            </p>
            <p>
              <img src="Images/About_pics/Instagram.svg" />
              INSTAGRAM
            </p>
            <p>
              <img src="Images/About_pics/Email.svg" />E MAIL
            </p>
          </div>
        </div>
      </div>
      <hr />
      <p>2021 iDEAL co Ltd</p>
    </div>
  );
};

export default About_mainpage;
